import { render } from "./MfgTuZhuangProduce.vue?vue&type=template&id=2cf72e4c&scoped=true"
import script from "./MfgTuZhuangProduce.vue?vue&type=script&lang=js"
export * from "./MfgTuZhuangProduce.vue?vue&type=script&lang=js"

import "./MfgTuZhuangProduce.vue?vue&type=style&index=0&id=2cf72e4c&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cf72e4c"]])

export default __exports__